<template>
  <div class="d-flex flex-column tw-mb-6">
    <h1 class="section-divider-underline">
      {{ $t("trainerProfile.address") }}
    </h1>
    <div class="row">
      <div class="col-md-6 tw-space-y-3">
        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("trainerProfile.province") }}</label
          >
          <div class="col-md-7">
            <a-select
              show-search
              placeholder="province"
              v-model="model.province_code"
              option-filter-prop="children"
              :class="{ 'is-invalid': errors.has('province_code') }"
              @change="onProvinceChange"
            >
              <a-select-option
                v-for="(province, index) in formViewDatas.provinces"
                :key="index"
                :value="province.province_code"
              >
                {{ province.name_en }}
              </a-select-option>
            </a-select>
            <div class="invalid-feedback" v-if="errors.has('province_code')">
              {{ errors.first("province_code") }}
            </div>
          </div>
        </div>

        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("trainerProfile.district") }}</label
          >
          <div class="col-md-7">
            <a-select
              show-search
              :loading="loading"
              :disabled="loading"
              v-model="model.district_code"
              option-filter-prop="children"
              :class="{ 'is-invalid': errors.has('district_code') }"
              @change="onDistrictChange"
            >
              <a-select-option
                v-for="(district, index) in districts"
                :key="index"
                :value="district.district_code"
              >
                {{ district.name_en }}
              </a-select-option>
            </a-select>
            <div class="invalid-feedback" v-if="errors.has('district_code')">
              {{ errors.first("district_code") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
          >
            {{ $t("trainerProfile.commune") }}
          </label>
          <div class="col-md-7">
            <a-select
              show-search
              :loading="loading"
              :disabled="loading"
              v-model="model.commune_code"
              option-filter-prop="children"
              :class="{ 'is-invalid': errors.has('commune_code') }"
              @change="onCommuneChange"
            >
              <a-select-option
                v-for="(commune, index) in communes"
                :key="index"
                :value="commune.commune_code"
              >
                {{ commune.name_en }}
              </a-select-option>
            </a-select>
            <div class="invalid-feedback" v-if="errors.has('commune_code')">
              {{ errors.first("commune_code") }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 tw-space-y-3">
        <div class="row">
          <label
            class="form-label col-form-label col-md-5 tw-text-right required"
            >{{ $t("trainerProfile.village") }}</label
          >
          <div class="col-md-7">
            <a-select
              show-search
              :loading="loading"
              :disabled="loading"
              v-model="model.village_code"
              option-filter-prop="children"
              :class="{ 'is-invalid': errors.has('village_code') }"
            >
              <a-select-option
                v-for="(village, index) in villages"
                :key="index"
                :value="village.village_code"
              >
                {{ village.name_en }}
              </a-select-option>
            </a-select>
            <div class="invalid-feedback" v-if="errors.has('village_code')">
              {{ errors.first("village_code") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-label col-form-label col-md-5 tw-text-right">
            {{ $t("trainerProfile.moreDetailAddress") }}
          </label>
          <div class="col-md-7">
            <textarea
              rows="2"
              v-model="model.more_detail_address"
              class="form-control"
              :class="{ 'is-invalid': errors.has('more_detail_address') }"
            ></textarea>
            <div
              class="invalid-feedback"
              v-if="errors.has('more_detail_address')"
            >
              {{ errors.first("more_detail_address") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";

export default {
  name: "detail",
  props: ["value", "validation"],
  data() {
    return {
      loading: false,
      model: {},
      errors: new Errors(),
      options: null,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("academic/trainerProfile", ["formViewDatas", "edit_data"]),
    districts() {
      return this.formViewDatas["districts"];
    },
    communes() {
      return this.formViewDatas["communes"];
    },
    villages() {
      return this.formViewDatas["villages"];
    },
  },
  methods: {
    ...mapActions("academic/trainerProfile", ["getFormViewData"]),
    async onProvinceChange(value) {
      this.loading = true;
      this.model.district_code = null;
      this.model.commune_code = null;
      this.model.village_code = null;
      await this.getFormViewData({
        index: "districts",
        params: {
          fnName: "districts",
          province_code: value,
        },
      }).finally(() => (this.loading = false));
    },
    async onDistrictChange(value) {
      this.loading = true;
      this.model.commune_code = null;
      this.model.village_code = null;
      await this.getFormViewData({
        index: "communes",
        params: {
          fnName: "communes",
          district_code: value,
        },
      }).finally(() => (this.loading = false));
    },
    async onCommuneChange(value) {
      this.loading = true;
      this.model.village_code = null;
      await this.getFormViewData({
        index: "villages",
        params: {
          fnName: "villages",
          commune_code: value,
        },
      }).finally(() => (this.loading = false));
    },
    clearOption() {
      this.model.status_reason_id = null;
      this.options = null;
    },
  },
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
